module.exports = __webpack_public_path__ + "media/images/client-26-47955b20f5ffcf0b41f4e76c826c21ca.png";